<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t("Roles") }}</h1>

        <b-card class="shadow">
            <div class="row">
                <div class="col-12">
                    <div
                        class="d-flex align-items-center justify-content-between mb-4"
                    >
                        <router-link
                            class="btn btn-primary"
                            to="/dashboard/admin/roles/add"
                        >
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                        </router-link>

                        <div>
                            <div class="input-group mb-3">
                                <b-input
                                    :placeholder="$t('Type to search')"
                                    class="form-control search-input"
                                    type="text"
                                    v-model="search"
                                    v-on:change="getRoles"
                                    aria-describedby="input-search"
                                />
                                <div class="input-group-append" role="button">
                                    <span
                                        class="input-group-text"
                                        id="input-search"
                                        ><i class="fas fa-search search-icon"
                                    /></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <b-card class="mb-3" no-body>
                        <loading-animation
                            :active.sync="loading"
                            :is-full-page="false"
                            :opacity="1"
                            color="#5895FF"
                        />
                        <b-table
                            :fields="[
                                {
                                    key: 'name',
                                    label: $t('Nome')
                                },
                                {
                                    key: 'users',
                                    label: $t('Nº Users')
                                },
                                {
                                    key: 'actions',
                                    label: '',
                                    class: 'text-right'
                                }
                            ]"
                            :items="rolesList"
                            :responsive="true"
                            striped
                            stacked="md"
                            fixed
                            hover
                            show-empty
                            small
                            outlined
                            table-class="mb-0"
                        >
                            <template v-slot:cell(name)="data">
                                {{ data.value }}
                            </template>
                            <template v-slot:cell(users)="data">
                                {{ data.value }}
                            </template>
                            <template v-slot:cell()="data">
                                <b-button
                                    :title="$t('Ver Permissões')"
                                    @click.prevent="
                                        getPermissions(data.item.permissions)
                                    "
                                    class="px-2 mb-0"
                                    size="xs"
                                    type="button"
                                    v-b-tooltip.hover
                                    variant="primary"
                                >
                                    <i class="mdi mdi-security" />
                                </b-button>

                                <b-button
                                    :title="$t('Edit role')"
                                    :to="
                                        '/dashboard/admin/roles/edit/' +
                                            data.item.id
                                    "
                                    class="px-2 mb-0"
                                    size="xs"
                                    type="button"
                                    v-b-tooltip.hover
                                    v-if="data.item.type !== 1"
                                    variant="success"
                                >
                                    <i class="mdi mdi-square-edit-outline" />
                                </b-button>
                                <b-button
                                    :title="$t('Delete role')"
                                    @click="deleteRole(data.item.id)"
                                    class="px-2 mb-0"
                                    size="xs"
                                    type="button"
                                    v-b-tooltip.hover
                                    v-if="data.item.type !== 1"
                                    variant="danger"
                                >
                                    <i class="fas fa-fw fa-trash" />
                                </b-button>
                            </template>
                            <template v-slot:empty="scope">
                                <div class="text-center my-5">
                                    <img
                                        :alt="$t('No results')"
                                        class="mb-5"
                                        src="/img/icons/robot.svg"
                                        style="max-height: 165px"
                                    />
                                    <h3 class="bold">
                                        {{ $t("No records found") }}
                                    </h3>
                                </div>
                            </template>
                            <template v-slot:emptyfiltered="scope">
                                <div class="text-center my-5">
                                    <img
                                        :alt="$t('No results')"
                                        class="mb-5"
                                        src="/img/icons/robot.svg"
                                        style="max-height: 165px"
                                    />
                                    <h3>
                                        {{
                                            $t(
                                                "No records match the entered search"
                                            )
                                        }}
                                    </h3>
                                </div>
                            </template>
                        </b-table>
                    </b-card>
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                            <div class="form-group d-inline-flex mb-0">
                                <select
                                    class="form-control"
                                    style="width: 70px"
                                    v-model="perPage"
                                    v-on:change="getRoles"
                                >
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                </select>
                            </div>
                            <div class="d-inline-flex ml-2">
                                <b-pagination
                                    :per-page="perPage"
                                    :total-rows="pagination.total"
                                    @change="changePage"
                                    v-model="page"
                                />
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                            <div class="float-lg-right">
                                {{ $t("Showing page") }}
                                {{ pagination.currentPage }} {{ $t("of") }}
                                {{ pagination.totalPages }} {{ $t("pages in") }}
                                {{ pagination.total }}
                                {{ $t("records") }}
                            </div>
                        </div>
                    </div>
                </div>
                <router-view />
            </div>
        </b-card>
        <b-modal
            id="modalPermission"
            centered
            size="xl"
            hide-footer
            title="Permissões"
        >
            <loading-animation
                :active.sync="loadingPermissions"
                :is-full-page="false"
                :opacity="1"
                color="#5895FF"
            />
            <div class="row m-0">
                <div
                    class="col-md-4 p-3"
                    v-for="(key, index) in permissions"
                    style="border: 1px solid #eee"
                    :key="index"
                >
                    <span v-if="permissions[index] == true">
                        <strong style="color: #5794fd">
                            <i class="far fa-check-square"></i>
                            {{ permissionsLabels[index] }}
                        </strong>
                    </span>
                    <span v-else>
                        <small style="color: #ccc">
                            <i class="fas fa-ban"></i>
                            {{ permissionsLabels[index] }}
                        </small>
                    </span>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "Roles",
    metaInfo() {
        return {
            title: this.$i18n.t("Roles")
        };
    },
    data() {
        return {
            page: 1,
            search: "",
            perPage: 10,
            loading: true,
            loadingPermissions: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            rolesList: [],
            permissions: [],
            permissionsLabels: []
        };
    },
    mounted() {
        this.getRoles();
    },
    methods: {
        getPermissions(value) {
            this.$bvModal.show("modalPermission");
            this.permissions = value;
            this.loadingPermissions = true;
            axios
                .get("api/dashboard/roles/permissions")
                .then(response => {
                    this.permissionsLabels =
                        response.data.data.controllerLabels;
                })
                .finally(() => (this.loadingPermissions = false));
        },

        // Change the page
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getRoles();
            }
        },
        // Get roles list
        getRoles() {
            this.loading = true;
            axios
                .get("api/dashboard/roles", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage
                    }
                })
                .then(response => {
                    this.rolesList = response.data.data;
                    this.pagination = response.data.pagination;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getRoles();
                    } else {
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // Delete role
        deleteRole(role) {
            swal.fire({
                title: this.$t("Are you sure?"),
                text: this.$t(
                    "Esta função só poderá ser excluída se não houver técnicos associados!"
                ),
                showCancelButton: true,
                cancelButtonText: this.$t("Cancel"),
                confirmButtonText: this.$t("Delete"),
                icon: "warning"
            }).then(value => {
                if (value) {
                    this.loading = true;
                    axios
                        .delete("api/dashboard/roles/" + role)
                        .then(response => {
                            this.getRoles();
                            this.$snack.success({
                                button: false,
                                text: response.data.data.message
                            });
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        }
    }
};
</script>
